import React, { useState } from 'react';
import { 
  Search, 
  Bell, 
  User, 
  Menu,
  LayoutDashboard,
  Users,
  Package,
  ShoppingCart,
  BarChart3,
  Settings,
  LogOut
} from 'lucide-react';
import { useSession } from '../contexts/SessionContext';
import './Navbar.css';

const Navbar = ({ activeTab, setActiveTab, userEmail, onToggleSidebar, sidebarCollapsed, children }) => {
  const { logout } = useSession();
  const [searchQuery, setSearchQuery] = useState('');
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const notifications = [
    { id: 1, message: 'New vendor registration pending approval', time: '2 min ago', unread: true },
    { id: 2, message: 'Low stock alert for Product #1234', time: '15 min ago', unread: true },
    { id: 3, message: 'Order #5678 has been completed', time: '1 hour ago', unread: false },
    { id: 4, message: 'Monthly report is ready', time: '2 hours ago', unread: false },
  ];

  const unreadCount = notifications.filter(n => n.unread).length;

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'vendors', label: 'Vendors', icon: Users },
    { id: 'products', label: 'Products', icon: Package },
    { id: 'orders', label: 'Orders', icon: ShoppingCart },
    { id: 'reports', label: 'Reports', icon: BarChart3 },
    { id: 'settings', label: 'Settings', icon: Settings },
  ];

  return (
    <header className="navbar">
      <div className="navbar-content">
        <div className="navbar-left">
          <button className="mobile-menu-btn" onClick={onToggleSidebar} aria-label={sidebarCollapsed ? 'Open menu' : 'Close menu'}>
            <Menu size={24} />
          </button>

          <div className="brand" aria-label="Brand">
            <div className="brand-logo" aria-hidden="true">
              <img
                className="brand-img"
                src={`${process.env.PUBLIC_URL || ''}/sonickart.jpg`}
                alt="SoniCKart"
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            </div>
          </div>

          <div className="search-container">
            <Search size={20} className="search-icon" />
            <input
              type="text"
              placeholder="Search vendors, products, orders..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        <div className="navbar-center">
          <nav className="navbar-nav">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  className={`nav-icon-btn ${activeTab === item.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(item.id)}
                  title={item.label}
                >
                  <Icon size={20} />
                </button>
              );
            })}
          </nav>
        </div>

        <div className="navbar-right">
          <div className="notification-container">
            <button 
              className="notification-btn"
              onClick={() => setShowNotifications(!showNotifications)}
            >
              <Bell size={20} />
              {unreadCount > 0 && (
                <span className="notification-badge">{unreadCount}</span>
              )}
            </button>
            
            {showNotifications && (
              <div className="notification-dropdown">
                <div className="notification-header">
                  <h3>Notifications</h3>
                  <button 
                    className="mark-all-read"
                    onClick={() => setShowNotifications(false)}
                  >
                    Mark all as read
                  </button>
                </div>
                <div className="notification-list">
                  {notifications.map((notification) => (
                    <div 
                      key={notification.id} 
                      className={`notification-item ${notification.unread ? 'unread' : ''}`}
                    >
                      <div className="notification-content">
                        <p className="notification-message">{notification.message}</p>
                        <span className="notification-time">{notification.time}</span>
                      </div>
                      {notification.unread && <div className="unread-dot"></div>}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Session Status Component */}
          {children}

          <div className="user-profile-container">
            <button 
              className="user-profile"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <div className="user-avatar">
                <User size={20} />
              </div>
              <div className="user-info">
                <span className="user-name">{userEmail || 'Vendor User'}</span>
                <span className="user-role">Vendor</span>
              </div>
            </button>
            
            {showUserMenu && (
              <div className="user-menu">
                <div className="user-menu-header">
                  <div className="user-avatar-large">
                    <User size={24} />
                  </div>
                  <div className="user-details">
                    <div className="user-name">{userEmail || 'Vendor User'}</div>
                    <div className="user-email">Vendor</div>
                  </div>
                </div>
                <div className="user-menu-divider"></div>
                <button className="user-menu-item" onClick={logout}>
                  <LogOut size={16} />
                  <span>Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
